export default "__VITE_ASSET__BwcdlKJ8__"